var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#36343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_304_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_304_88",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 8,
    width: 11,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11,
    y: 8,
    width: 11,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.436 9.042H16.768C17.9333 9.042 18.8643 9.39667 19.561 10.106C20.2577 10.8153 20.606 11.797 20.606 13.051C20.606 14.2923 20.2387 15.2677 19.504 15.977C18.782 16.6863 17.8193 17.041 16.616 17.041H13.861V22H12.436V9.042ZM16.578 15.863C17.4267 15.863 18.0727 15.6287 18.516 15.16C18.9593 14.6787 19.181 13.9757 19.181 13.051C19.181 12.1263 18.9593 11.4233 18.516 10.942C18.0727 10.4607 17.4267 10.22 16.578 10.22H13.861V15.863H16.578Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.436 9.042H16.768C17.9333 9.042 18.8643 9.39667 19.561 10.106C20.2577 10.8153 20.606 11.797 20.606 13.051C20.606 14.2923 20.2387 15.2677 19.504 15.977C18.782 16.6863 17.8193 17.041 16.616 17.041H13.861V22H12.436V9.042ZM16.578 15.863C17.4267 15.863 18.0727 15.6287 18.516 15.16C18.9593 14.6787 19.181 13.9757 19.181 13.051C19.181 12.1263 18.9593 11.4233 18.516 10.942C18.0727 10.4607 17.4267 10.22 16.578 10.22H13.861V15.863H16.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.436 9.042V8.542H11.936V9.042H12.436ZM19.561 10.106L19.2043 10.4564L19.2043 10.4564L19.561 10.106ZM19.504 15.977L19.1567 15.6173L19.1536 15.6203L19.504 15.977ZM13.861 17.041V16.541H13.361V17.041H13.861ZM13.861 22V22.5H14.361V22H13.861ZM12.436 22H11.936V22.5H12.436V22ZM18.516 15.16L18.8793 15.5036L18.8838 15.4987L18.516 15.16ZM18.516 10.942L18.1482 11.2807L18.1482 11.2807L18.516 10.942ZM13.861 10.22V9.72H13.361V10.22H13.861ZM13.861 15.863H13.361V16.363H13.861V15.863ZM12.436 9.542H16.768V8.542H12.436V9.542ZM16.768 9.542C17.8241 9.542 18.6178 9.8592 19.2043 10.4564L19.9177 9.75565C19.1109 8.93413 18.0426 8.542 16.768 8.542V9.542ZM19.2043 10.4564C19.7867 11.0493 20.106 11.8921 20.106 13.051H21.106C21.106 11.7019 20.7287 10.5813 19.9177 9.75564L19.2043 10.4564ZM20.106 13.051C20.106 14.188 19.7733 15.0219 19.1567 15.6173L19.8513 16.3367C20.704 15.5134 21.106 14.3966 21.106 13.051H20.106ZM19.1536 15.6203C18.5424 16.2208 17.7148 16.541 16.616 16.541V17.541C17.9239 17.541 19.0216 17.1519 19.8544 16.3337L19.1536 15.6203ZM16.616 16.541H13.861V17.541H16.616V16.541ZM13.361 17.041V22H14.361V17.041H13.361ZM13.861 21.5H12.436V22.5H13.861V21.5ZM12.936 22V9.042H11.936V22H12.936ZM16.578 16.363C17.5187 16.363 18.3143 16.1009 18.8792 15.5036L18.1528 14.8164C17.8311 15.1565 17.3347 15.363 16.578 15.363V16.363ZM18.8838 15.4987C19.4417 14.893 19.681 14.0494 19.681 13.051H18.681C18.681 13.9019 18.477 14.4643 18.1482 14.8213L18.8838 15.4987ZM19.681 13.051C19.681 12.0526 19.4417 11.209 18.8838 10.6033L18.1482 11.2807C18.477 11.6377 18.681 12.2001 18.681 13.051H19.681ZM18.8838 10.6033C18.3197 9.9908 17.5226 9.72 16.578 9.72V10.72C17.3308 10.72 17.8257 10.9305 18.1482 11.2807L18.8838 10.6033ZM16.578 9.72H13.861V10.72H16.578V9.72ZM13.361 10.22V15.863H14.361V10.22H13.361ZM13.861 16.363H16.578V15.363H13.861V16.363Z",
    fill: "white",
    mask: "url(#path-2-outside-1_304_88)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_304_88",
    x: 10.436,
    y: 9.04199,
    width: 12.1699,
    height: 16.958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_304_88"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_304_88",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.352f955dad1c899f6eaa104e737e8203.svg";
export { ForwardRef as ReactComponent };